// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MaterialCard_wrapper__1dqmH","button":"MaterialCard_button__25dUU","adminWrap":"MaterialCard_adminWrap__-urmB","adminBtn":"MaterialCard_adminBtn__28s-o"};